/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICRTouchConnectionSites } from './ICRTouchConnectionSites';
import {
    ICRTouchConnectionSitesFromJSON,
    ICRTouchConnectionSitesFromJSONTyped,
    ICRTouchConnectionSitesToJSON,
    ICRTouchConnectionSitesToJSONTyped,
} from './ICRTouchConnectionSites';

/**
 * 
 * @export
 * @interface ShowIcrTouchConnectionSitesResponse
 */
export interface ShowIcrTouchConnectionSitesResponse {
    /**
     * 
     * @type {Array<ICRTouchConnectionSites>}
     * @memberof ShowIcrTouchConnectionSitesResponse
     */
    data: Array<ICRTouchConnectionSites>;
}

/**
 * Check if a given object implements the ShowIcrTouchConnectionSitesResponse interface.
 */
export function instanceOfShowIcrTouchConnectionSitesResponse(value: object): value is ShowIcrTouchConnectionSitesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowIcrTouchConnectionSitesResponseFromJSON(json: any): ShowIcrTouchConnectionSitesResponse {
    return ShowIcrTouchConnectionSitesResponseFromJSONTyped(json, false);
}

export function ShowIcrTouchConnectionSitesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowIcrTouchConnectionSitesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ICRTouchConnectionSitesFromJSON)),
    };
}

  export function ShowIcrTouchConnectionSitesResponseToJSON(json: any): ShowIcrTouchConnectionSitesResponse {
      return ShowIcrTouchConnectionSitesResponseToJSONTyped(json, false);
  }

  export function ShowIcrTouchConnectionSitesResponseToJSONTyped(value?: ShowIcrTouchConnectionSitesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ICRTouchConnectionSitesToJSON)),
    };
}

